import { createSlice } from "@reduxjs/toolkit";
import {
  getPerformanceConfig,
  getEmployeeCTC,
  getPerformanceRatings,
  getAllPerformanceRatings,
  getPerformanceCalculations,
} from "../action/performanceIndexAction";

const initialState = {
  config: null,
  employeeCTC: [],
  performanceRatings: [],
  allPerformanceRatings: [],
  performanceCalculations: [],
};

export const performanceIndexSlice = createSlice({
  name: "performanceIndex",
  initialState,
  extraReducers: (builder) => {
    builder
      .addCase(getPerformanceConfig.fulfilled, (state, action) => {
        state.config = action.payload;
      })
      .addCase(getEmployeeCTC.fulfilled, (state, action) => {
        state.employeeCTC = action.payload;
      })
      .addCase(getPerformanceRatings.fulfilled, (state, action) => {
        state.performanceRatings = action.payload;
      })
      .addCase(getAllPerformanceRatings.fulfilled, (state, action) => {
        state.allPerformanceRatings = action.payload;
      })
      .addCase(getPerformanceCalculations.fulfilled, (state, action) => {
        state.performanceCalculations = action.payload;
      });
  },
});

export default performanceIndexSlice.reducer;

